export default __webpack_public_path__ + "static/media/icon-payment-method.15bae9c8.svg";